import { createFileRoute } from '@tanstack/react-router';
import { SignInForm } from '@/lib/auth/SignInForm';

export const Route = createFileRoute('/sign-in/')({
  component: AdminSignIn,
});

// No self-service account creation — admin accounts are founder-provisioned
// (spec §3: "Admin = allow-listed profiles.is_admin, never a client-side
// flag"), so `allowSignUp` is always false here.
//
// `onSignedIn` is deliberately a no-op — see __root.tsx's isPublic branch
// for why navigating here races the AuthProvider's deferred session-context
// update. The root guard's own "signed in but on /sign-in" redirect takes
// over once the session lands.
function AdminSignIn() {
  return (
    <section className="rounded-card border border-border bg-surface p-xl shadow-card">
      <h1 className="text-screen-title font-extrabold tracking-tight text-ink">Admin sign in</h1>
      <p className="mt-xs text-body text-ink-2">Founder accounts only. A second factor follows.</p>
      <div className="mt-lg">
        <SignInForm allowSignUp={false} onSignedIn={() => {}} />
      </div>
    </section>
  );
}
